var map = {
	"./bell.svg": 61924,
	"./buy_crypto.svg": 28695,
	"./career.svg": 3276,
	"./exchange.svg": 77375,
	"./explore.svg": 19590,
	"./help_centre.svg": 44822,
	"./identification.svg": 41708,
	"./message-question.svg": 59852,
	"./myr.svg": 66063,
	"./otc.svg": 94586,
	"./profile.svg": 41811,
	"./security.svg": 63442,
	"./settings.svg": 86505,
	"./usd.svg": 62687,
	"./wallet.svg": 91408
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6062;